import {
    GET_MODULES,
    GET_MODULES_SUCCESS,
    GET_MODULES_FAILURE,
    CREATE_MODULES,
    CREATE_MODULES_SUCCESS,
    CREATE_MODULES_FAILURE,
    SHOW_MODULES,
    SHOW_MODULES_SUCCESS,
    SHOW_MODULES_FAILURE,
    UPDATE_MODULES,
    UPDATE_MODULES_SUCCESS,
    UPDATE_MODULES_FAILURE
  } from "../../Actions/types";
  
  const initialState = {
    getLoader: false,
    getError: null,
    getData: null,
    showLoader: false,
    showData: null,
    showError: null,
    createLoader: false,
    createData: null,
    createError: null,
    uploadLoader: false,
    uploadData: null,
    uploadError: false,
    editLoader: false,
    editData: null,
    editError: null,
  };
  function ModuleReducer(state = initialState, action) {
    
    switch (action.type) {
      case GET_MODULES:
        return { ...state, getLoader: true };
      case GET_MODULES_SUCCESS:
        return { ...state, getData: action?.payload, getLoader: false };
      case GET_MODULES_FAILURE:
        return { ...state, getError: true, getLoader: false };
  
      case SHOW_MODULES:
        return { ...state, showLoader: true };
      case SHOW_MODULES_SUCCESS:
        return {
          ...state,
          showData: action?.payload,
          showLoader: false,
        };
      case SHOW_MODULES_FAILURE:
        return {
          ...state,
          showError: true,
          showLoader: false,
        };
      //update
      case UPDATE_MODULES:
        return { ...state, editLoader: true };
  
      case UPDATE_MODULES_SUCCESS:
        return {
          ...state,
          editData: action?.payload || null,
          editLoader: false,
          editError: false
        };
      case UPDATE_MODULES_FAILURE:
        return {
          ...state,
          editError: true,
          editLoader: false,
          editData: null
        };
      case CREATE_MODULES:
        return { ...state, createLoader: true };
      case CREATE_MODULES_SUCCESS:
        return {
          ...state,
          createData: action?.payload,
          createLoader: false,
        };
      case CREATE_MODULES_FAILURE:
        return {
          ...state,
          createError: true,
          createLoader: false,
        };
  
      default:
        return state;
    }
  }
  
  export default ModuleReducer;
  